import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PagamentosComponent } from './pagamentos.component';

const routes: Routes = [
  { path: '', component: PagamentosComponent },
  {
    path: ':pagamentoId',
    loadChildren: () => import('./pagamentos-detalhes/pagamentos-detalhes.page.module').then(m => m.PagamentosDetalhesPageModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PagamentosRoutingModule { }
